import ValidationType from '../ValidationType';

class MinTextLength extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (!fieldResponse.currentValue || fieldResponse.currentValue.toString().length < parseInt(validation.value)) {
        errors.push(this.createValidationError({
          fieldResponse: fieldResponse,
          key: 'ERROR_MIN_TEXT_LENGTH',
          values: { value: validation.value },
          message: `Minimum text length is ${validation.value} characters`,
        }));
      }
    }
    return errors;
  }
}

export default MinTextLength;
